{
  "components": {
    "templates": {
      "title": "Action Items templates",
      "selectionDrawer": {
        "title": "Action Items templates",
        "searchPlaceholder": "Search template groups...",
        "saveButton": {
          "creating_one": "Creating {{count}} action item...",
          "creating_other": "Creating {{count}} action items...",
          "complete_one": "Complete action data for {{count}} template",
          "complete_other": "Complete action data for {{count}} templates"
        },
        "validation": {
          "errorMessage_one": "Please fill in all required fields for {{count}} template before creating action items.",
          "errorMessage_other": "Please fill in all required fields for {{count}} templates before creating action items."
        },
        "loading": "Loading template groups...",
        "noTemplates": "No templates found.",
        "validationAlert": {
          "message_one": "{{count}} template has missing required fields",
          "message_other": "{{count}} templates have missing required fields"
        },
        "missingFields": {
          "missing": "Missing: {{fields}}",
          "file": "File",
          "meetingLink": "Meeting link",
          "meetingDate": "Meeting date",
          "link": "Link",
          "title": "Title",
          "stage": "Stage"
        },
        "groupCard": {
          "description_one": "Contains {{count}} action item",
          "description_other": "Contains {{count}} action items"
        },
        "editForm": {
          "title": "Edit Template"
        },
        "templateList": {
          "loading": "Loading templates...",
          "title": "Templates",
          "description": "Click on a template to edit it. All templates will be created when you save."
        }
      },
      "detailView": {
        "title": "{{groupName}} Templates",
        "previewTitle": "Template Preview",
        "previewDescription": "Click on a template to preview how it would look when filled with data."
      }
    }
  },
  "notifications": {
    "success": {
      "TEMPLATE_ACTION_ITEMS_CREATED": {
        "description_one": "Successfully created {{count}} action item",
        "description_other": "Successfully created {{count}} action items"
      }
    }
  }
}
